// extracted by mini-css-extract-plugin
export default {"Heading":"no-data-card-module__Heading--wMYlF","Box":"no-data-card-module__Box--g5fE2"};